import { render, staticRenderFns } from "./loadingCircle.vue?vue&type=template&id=1bedff36"
import script from "./loadingCircle.vue?vue&type=script&setup=true&lang=js"
export * from "./loadingCircle.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports